export default __webpack_public_path__ + "static/media/offer5.caf97f68.jpg";